<template>
  <div>
    <el-card class="page-container">
      <h1 class="title-biaoti">配置key</h1>
      <el-row :gutter="20" class="user-options">
        <el-input type="text" v-model="configKey1" placeholder="请输入configKey" style="width: 250px" clearable></el-input>
        <el-select style="width: 160px" class="header-item" v-model="valid" placeholder="">
          <el-option v-for="(item, itemIndex) in valids" :key="itemIndex" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-select style="width: 160px" class="header-item" v-model="queryChannel" placeholder="选择渠道" filterable>
          <el-option key="" value="" label="ALL"></el-option>
          <el-option v-for="(item, itemIndex) in allChannel" :key="item.id" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
        <el-select style="width: 160px" class="header-item" v-model="status" placeholder="">
          <el-option v-for="(item, itemIndex) in statuss" :key="itemIndex" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-select style="width: 160px" class="header-item" v-model="typeNameSearch" placeholder="">
          <el-option v-for="(item, itemIndex) in keyTypeList" :key="itemIndex" :label="item.typeName"
            :value="item.id"></el-option>
        </el-select>

        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="cre"> 创建 </el-button>
        <el-button type="info" @click="openNewType"> 新增分类 </el-button>
        <el-button type="warning" @click="asd">配置字典API</el-button>
      </el-row>
      <!-- 创建弹窗 -->
      <el-drawer title="" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
        <div class="add">
          <el-row class="ruid">
            <div class="ruids">
              <div>
                <span>name:</span>
                <el-input v-model="name" style="width: 160px" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="ruids">
              <div>
                <span>键值:</span>
                <el-input v-model="configKey" style="width: 160px" placeholder="请输入内容"></el-input>
              </div>

              <div>
                <span>国家:</span>
                <el-select style="width: 160px" v-model="country" placeholder>
                  <el-option v-for="(item, itemIndex) in countryList" v-bind:key="itemIndex + 99" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="ruids" v-if="!msg">
              <div>
                <span>分类:</span>
                <el-select style="width: 160px" class="header-item" v-model="addTypeKey" placeholder="">
                  <el-option v-for="(item, itemIndex) in keyTypeList" :key="itemIndex" :label="item.typeName"
                    :value="item.id"></el-option>
                </el-select>
              </div>
            </div>
            <div class="ruids">
              <div>
                <span>渠道:</span>
                <el-select style="width: 160px" v-model="channel" placeholder>
                  <el-option v-for="(item, itemIndex) in channelsList" v-bind:key="itemIndex" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
              <div>
                <span>语言:</span>
                <el-select style="width: 160px" v-model="language" placeholder>
                  <el-option v-for="(item, itemIndex) in languageList" v-bind:key="itemIndex + 199" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="ruids">
              <div>
                <span>是否可用:</span>
                <el-select style="width: 100px" v-model="valid_" placeholder>
                  <el-option v-for="(item, itemIndex) in valids_" v-bind:key="itemIndex + 99" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
              <div>
                <span>使用状态:</span>
                <el-select style="width: 120px" v-model="status_0" placeholder>
                  <el-option v-for="(item, itemIndex) in status_1" v-bind:key="itemIndex + 99" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="gd" @click="slist = !slist">更多</div>
            <div class="span" v-if="slist">
              <div class="ruids">
                <div>
                  <span>平台开关:</span>
                  <el-select style="width: 100px" v-model="platform" placeholder>
                    <el-option v-for="(item, itemIndex) in platforms" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
                <div>
                  <span>版本开关:</span>
                  <el-select style="width: 100px" v-model="ver" placeholder>
                    <el-option v-for="(item, itemIndex) in vers" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
                <div>
                  <span>是否忽略默认值开关:</span>
                  <el-select style="width: 100px" v-model="needIgnoreDefault" placeholder>
                    <el-option v-for="(item, itemIndex) in needIgnoreDefaults" v-bind:key="itemIndex + 99"
                      :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="ruids">
                <div>
                  <span>大于等于版本:</span>
                  <el-select style="width: 100px" v-model="thanVer" placeholder>
                    <el-option v-for="(item, itemIndex) in thanVers" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
                <div>
                  <span>小于等于版本:</span>
                  <el-select style="width: 100px" v-model="lessVer" placeholder>
                    <el-option v-for="(item, itemIndex) in lessVers" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="ruids">
                <div>
                  <span>是否新用户:</span>
                  <el-select style="width: 100px" v-model="isNew" placeholder>
                    <el-option v-for="(item, itemIndex) in isNews" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
                <div>
                  <span>是否付费用户:</span>
                  <el-select style="width: 100px" v-model="isPay" placeholder>
                    <el-option v-for="(item, itemIndex) in isPays" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="ruids">
                <div>
                  <span>用户boss等级:</span>
                  <el-select style="width: 100px" v-model="bossLevel" placeholder>
                    <el-option v-for="(item, itemIndex) in isPays" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="ruids">
                <div>
                  <span>主播等级:</span>
                  <el-select style="width: 100px" v-model="hostLevel" placeholder>
                    <el-option v-for="(item, itemIndex) in isPays" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="ruids">
                <div>
                  <span>代理id:</span>
                  <el-select style="width: 100px" v-model="agentId" placeholder>
                    <el-option v-for="(item, itemIndex) in isPays" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="ruids">
                <div>
                  <span>身份:</span>
                  <el-select style="width: 100px" v-model="gender" placeholder>
                    <el-option v-for="(item, itemIndex) in isPays" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="ruids">
                <div>
                  <span>马甲包:</span>
                  <el-select style="width: 100px" v-model="majia" placeholder>
                    <el-option v-for="(item, itemIndex) in isPays" v-bind:key="itemIndex + 99" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="ruids">
              <div class="text">
                <span>值:</span>
                <el-input style="width: 260px" type="textarea" :rows="4" placeholder="请输入内容" v-model="defaultVal">
                </el-input>
              </div>
            </div>
            <div class="ruids" v-if="!msg">
              <div class="text">
                <span>描述:</span>
                <el-input style="width: 260px" type="textarea" :rows="4" placeholder="请输入描述" v-model="addDesc">
                </el-input>
              </div>
            </div>
          </el-row>
          <el-row class="buttom">
            <el-button type="primary" v-if="!msg" @click="establish()">创建</el-button>
            <el-button type="primary" v-if="msg" @click="establish(1)">修改</el-button>
          </el-row>
        </div>
      </el-drawer>
      <!--新增分类-->
      <el-dialog title="新增分类" :visible.sync="newTypeShow" width="30%" :before-close="newTypeClose">
        <el-input v-model="addTypeName" placeholder="请输入类型名称"></el-input>
        <div class="tag">
          <el-tag type="success" v-for="(item, ind) in keyTypeList" :key="ind">{{ item.typeName }}</el-tag>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="newTypeClose">取 消</el-button>
          <el-button type="primary" @click="addType" :loading="load">新增</el-button>
        </span>
      </el-dialog>
      <!--其他信息修改-->
      <el-dialog title="其他信息修改" :visible.sync="editTypeShow" width="30%" :before-close="editTypeClose">
        <label class="editTypeItem">分类
          <el-select style="width: 160px" class="header-item" v-model="editType.keyType" placeholder="">
            <el-option v-for="(item, itemIndex) in keyTypeList" :key="itemIndex" :label="item.typeName"
              :value="item.id"></el-option> </el-select></label>

        <label class="editTypeItem">描述
          <el-input type="textarea" :rows="2" desc placeholder="请输入描述" v-model="editType.desc">
          </el-input></label>

        <span slot="footer" class="dialog-footer">
          <el-button @click="editTypeClose">取 消</el-button>
          <el-button type="primary" @click="editTypeInfo" :loading="load">修改</el-button>
        </span>
      </el-dialog>
      <!-- 表格 -->
      <el-row class="user-options">
        <el-table height="60vh" style="width: 100%" :data="dayChatDetailData" v-loading="login1" border>
          <el-table-column prop="name" width="100px" label="name" align="center" fixed>
            <template slot-scope="scope">
              <div @click="rows(scope.row)" class="bule">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="configKey" label="键" align="center" fixed>
            <template slot-scope="scope">
              <div @click="rows(scope.row)" class="bule">
                {{ scope.row.configKey }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="keyName" label="所属分类" align="center">
          </el-table-column>
          <el-table-column width="180px" prop="desc" label="描述" align="center">
            <template slot-scope="scope">
              <div v-for="(item, i) in notes_s(scope.row.desc)" :key="i">
                {{ item }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="platform" label="平台筛选开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.platform == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="channel" label="渠道筛选开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.channel == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="countryCode" label="国家码筛选开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.countryCode == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="langId" label="语言码筛选开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.langId == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="isNew" label="是否新用户筛选开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.isNew == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="isPay" label="是否付费用户筛选开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.isPay == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column label="身份开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.gender == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column label="马甲开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.majia == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="ver" label="=版本号开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.ver == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="needIgnoreDefault" label="=是否忽略默认值开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.needIgnoreDefault == 1
                  ? 'el-icon-check colore'
                  : 'el-icon-close colorer'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="thanVer" label=">=版本号开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.thanVer == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="lessVer" label="<=版本号开关" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.lessVer == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="agentId" label="代理id" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.agentId == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="bossLevel" label="用户boss等级" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.bossLevel == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="hostLevel" label="主播等级" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.hostLevel == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>

          <el-table-column prop="status" label="使用端" align="center">
            <template slot-scope="scope">
              <i :class="scope.row.status == 0
                  ? 'el-icon-close colorer'
                  : 'el-icon-check colore'
                "></i>
            </template>
          </el-table-column>
          <el-table-column prop="valid" label="状态" align="center">
            <template slot-scope="scope">
              <div class="va" @click="_valid(scope.row)">
                {{ scope.row.valid == 0 ? '不可用' : '可用' }}(切换)
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ctime" label="创建时间" align="center">
            <template slot-scope="scope">
              {{ format_(scope.row.ctime) }}
            </template>
          </el-table-column>
          <el-table-column prop="mtime" label="修改时间" align="center">
            <template slot-scope="scope">
              {{ format_(scope.row.mtime) }}
            </template>
          </el-table-column>
          <el-table-column prop="operator" label="操作人" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" width="130">
            <template slot-scope="scope" class="buttons">
              <el-button type="primary" size="mini" @click="modify(scope.row)">修改</el-button>
              <el-button type="primary" size="mini" @click="selectKeyType(scope.row)">分类描述</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-card>
    <Val :dayChatDetailData="dayChatDetailData" ref="val"></Val>
  </div>
</template>

<script>
import Val from './val.vue'
export default {
  components: {
    Val,
  },
  data() {
    return {
      // 所有渠道列表
      allChannel: [],
      slist: false,
      id: '',
      bossLevel: 0,
      agentId: 0,
      gender: 0,
      majia:0,
      queryChannel: '',
      configKey1: '',
      hostLevel: 0,
      msg: false,
      channel: 0,
      name: '',
      channelsList: [
        {
          label: '关',
          value: 0,
        },
        {
          label: '开',
          value: 1,
        },
      ],
      country: 0,
      countryList: [
        {
          label: '关',
          value: 0,
        },
        {
          label: '开',
          value: 1,
        },
      ],
      drawer: false,
      direction: 'rtl',
      // 加载
      login1: false,
      valid: 1,

      valids: [
        {
          label: 'total',
          value: -1,
        },
        {
          label: '可用',
          value: 1,
        },
        {
          label: '不可用',
          value: 0,
        },
      ],
      status: -1,
      statuss: [
        {
          label: 'ALL',
          value: -1,
        },
        {
          label: '客户端可用',
          value: 1,
        },
        {
          label: '后端可用',
          value: 2,
        },
        {
          label: '双端可用',
          value: 3,
        },
      ],
      platform: 0,
      platforms: [
        {
          label: '关',
          value: 0,
        },
        {
          label: '开',
          value: 1,
        },
      ],
      ver: 0,
      vers: [
        {
          label: '关',
          value: 0,
        },
        {
          label: '开',
          value: 1,
        },
      ],
      needIgnoreDefault: 0,
      needIgnoreDefaults: [
        {
          label: '不忽略',
          value: 0,
        },
        {
          label: '忽略',
          value: 1,
        },
      ],
      thanVer: 0,
      thanVers: [
        {
          label: '关',
          value: 0,
        },
        {
          label: '开',
          value: 1,
        },
      ],
      lessVer: 0,
      lessVers: [
        {
          label: '关',
          value: 0,
        },
        {
          label: '开',
          value: 1,
        },
      ],
      isNew: 0,
      isNews: [
        {
          label: '关',
          value: 0,
        },
        {
          label: '开',
          value: 1,
        },
      ],
      isPay: 0,
      isPays: [
        {
          label: '关',
          value: 0,
        },
        {
          label: '开',
          value: 1,
        },
      ],
      status_0: 1,
      status_1: [
        {
          label: '客户端可用',
          value: 1,
        },
        {
          label: '后端可用',
          value: 2,
        },
        {
          label: '双端可用',
          value: 3,
        },
      ],
      valid_: 1,
      valids_: [
        {
          label: '不可用',
          value: 0,
        },
        {
          label: '可用',
          value: 1,
        },
      ],
      operator: this.$store.getters.username,

      language: 0,
      languageList: [
        {
          label: '关',
          value: 0,
        },
        {
          label: '开',
          value: 1,
        },
      ],
      configKey: '',
      defaultVal: '',
      addDesc: '',
      addTypeKey: 0,
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],
      row: '',
      //新增分类
      typeNameSearch: 0,
      newTypeShow: false,
      editTypeShow: false,
      load: false,
      keyTypeList: [],
      addTypeName: '',
      editType: {
        id: 0,
        desc: '',
        keyType: 0,
      },
    }
  },
  created() {
    // this.getDayChatDetai()
    this.queryTypeList()
    this.getChannelList()
  },
  methods: {
    async getChannelList() {
      const { data: res } = await this.$axios(
        this.$store.getters.path.newChannelList +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      )
      if (res.code == 0) {
        this.allChannel = res.data
      }
    },
    notes_s(notes) {
      if (notes == undefined) return
      notes = notes.split(/[(\n)\n]+/)
      return notes
    },
    rows(row) {
      this.$refs.val.row = row
      this.$refs.val.getDayChatDetai()
    },
    status_(data) {
      let a = {
        0: '不可用',
        1: '客户端可用',
        2: '后台可用',
        3: '双端可用',
      }
      return a[data]
    },
    format_(data) {
      let date = new Date(data * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      let h = date.getHours() + ':'
      let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true
      let data = {
        configKey: this.configKey1,
        valid: this.valid,
        status: this.status,
        keyType: this.typeNameSearch,
        queryChannel: this.queryChannel,
      }
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_key_list +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        data
      )
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data
      this.dayChatDetailData.map((i) => {
        this.keyTypeList.map((j) => {
          if (i.keyType === j.id) i.keyName = j.typeName
        })
      })
      this.total = res.data.total
    },
    // 创建/修改
    async establish(num) {
      if (this.defaultVal == '' || this.defaultVal == undefined) {
        return this.$message.error('值，不能为空')
      }
      let url =
        this.$store.getters.path.config_key_create +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        channel: this.channel,
        countryCode: this.country,
        configKey: this.configKey,
        platform: this.platform,
        langId: this.language,
        isPay: this.isPay,
        isNew: this.isNew,
        ver: this.ver,
        needIgnoreDefault: this.needIgnoreDefault,
        thanVer: this.thanVer,
        lessVer: this.lessVer,
        status: this.status_0,
        name: this.name,
        valid: this.valid_,
        operator: this.operator,
        defaultVal: this.defaultVal,
        desc: this.addDesc,
        agentId: this.agentId,
        gender: this.gender,
        majia: this.majia,
        bossLevel: this.bossLevel,
        hostLevel: this.hostLevel,
        keyType: this.addTypeKey,
      }
      this.slist = false
      if (num == 1) {
        url =
          this.$store.getters.path.config_key_update +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
        data = {
          id: this.id,
          channel: this.channel,
          countryCode: this.country,
          configKey: this.configKey,
          platform: this.platform,
          langId: this.language,
          isPay: this.isPay,
          isNew: this.isNew,
          ver: this.ver,
          needIgnoreDefault: this.needIgnoreDefault,
          name: this.name,
          valid: this.valid_,
          thanVer: this.thanVer,
          lessVer: this.lessVer,
          status: this.status_0,
          operator: this.operator,
          hostLevel: this.hostLevel,
          bossLevel: this.bossLevel,
          agentId: this.agentId,
          gender: this.gender,
          majia: this.majia,
          defaultVal: this.defaultVal,
        }
        this.slist = true
      }
      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.drawer = false
      this.getDayChatDetai()
      this.rows()
    },
    cre() {
      this.channel = 0
      this.country = 0
      this.platform = 0
      this.ver = 0
      this.needIgnoreDefault = 0
      this.thanVer = 0
      this.lessVer = 0
      this.isNew = 0
      this.isPay = 0
      this.status_0 = 1
      this.valid_ = 1
      this.language = 0
      this.configKey = ''
      this.defaultVal = ''
      this.addTypeKey = 0
      this.agentId = 0
      this.bossLevel = 0
      this.hostLevel = 0
      this.addDesc = ''
      this.name = ''
      this.drawer = true
      this.msg = false
    },
    // 修改
    modify(row) {
      this.id = row.id
      this.msg = true
      this.channel = row.channel
      this.country = row.countryCode
      this.configKey = row.configKey
      this.platform = row.platform
      this.language = row.langId
      this.isPay = row.isPay
      this.isNew = row.isNew
      this.name = row.name
      this.ver = row.ver
      this.needIgnoreDefault = row.needIgnoreDefault
      this.thanVer = row.thanVer
      this.valid_ = row.valid
      this.lessVer = row.lessVer
      this.status_0 = row.status
      this.agentId = row.agentId
      this.bossLevel = row.bossLevel
      this.hostLevel = row.hostLevel
      this.drawer = true
    },
    asd() {
      window.open(
        'https://www.tapd.cn/66567871/markdown_wikis/show/#1166567871001000261'
      )
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    },
    handleClose() {
      this.drawer = false
    },
    async _valid(row) {
      let num = 0
      if (row.valid == 0) {
        num = 1
      } else {
        num = 0
      }
      let url =
        this.$store.getters.path.config_key_updateValid +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        id: row.id,
        valid: num,
        operator: this.operator,
      }
      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.getDayChatDetai()
    },
    newTypeClose() {
      this.newTypeShow = false
      this.addTypeName = ''
    },
    editTypeClose() {
      this.editType = {
        id: 0,
        desc: '',
        keyType: 0,
      }
      this.editTypeShow = false
    },
    openNewType() {
      this.queryTypeList()
      this.newTypeShow = true
    },
    async queryTypeList() {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.config_val_type_list,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) return this.$message(res.msg)
      this.keyTypeList = res.data
    },
    async addType() {
      if (this.addTypeName.trim().length === 0) return
      this.load = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.config_val_type_add,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          typeName: this.addTypeName,
        },
      })
      this.load = false
      if (res.code != 0) return this.$message(res.msg)
      this.newTypeClose()
    },
    selectKeyType(row) {
      this.editTypeShow = true
      this.editType.id = row.id
      this.editType.keyType = row.keyType
      this.editType.desc = row.desc
    },
    async editTypeInfo() {
      let url =
        this.$store.getters.path.config_key_updateValid +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        id: this.editType.id,
        desc: this.editType.desc,
        keyType: this.editType.keyType,
        operator: this.operator,
      }
      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.msg)
      this.getDayChatDetai()
      this.editTypeClose()
    },
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}

.add {
  padding: 0 0 50px;

  .ruid,
  .span {
    >div {
      margin: 0 0 20px;

      > :nth-child(1) {
        margin: 0 0 20px;
      }

      .text {
        display: flex;
        align-items: center;
      }

      span {
        width: 120px;
        display: inline-block;
        margin: 0 30px 10px;
      }
    }
  }

  .buttom {
    display: flex;
    justify-content: flex-end;
    margin: 0 100px;
  }
}

.bule {
  color: #409eff;
}

.colorer {
  font-size: 18px;
  color: red;
}

.colore {
  font-size: 18px;
  color: #1dad21;
}

.gd {
  color: red;

  display: flex;
  justify-content: flex-end;
  padding: 0 50px;
  cursor: pointer;
  margin: -50px 0 0;
}

.va {
  color: #1dad21;
  cursor: pointer;
}

.asd {
  position: absolute;
  right: 0;
  top: 10px;
  cursor: pointer;
}

.tag {
  margin-top: 10px;

  >* {
    margin: 3px;
  }
}

.editTypeItem {
  margin-bottom: 10px;
  display: flex;

  >* {
    margin-left: 10px;
  }

  .el-textarea {
    width: 250px;
  }
}

.cell>button {
  margin-left: 0 !important;
  margin: 2px;
}
</style>
